import { render, staticRenderFns } from "./ForgetModel.vue?vue&type=template&id=06a233e2&scoped=true&"
import script from "./ForgetModel.vue?vue&type=script&lang=js&"
export * from "./ForgetModel.vue?vue&type=script&lang=js&"
import style0 from "./ForgetModel.vue?vue&type=style&index=0&id=06a233e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a233e2",
  null
  
)

export default component.exports